import clsx from 'clsx';
import * as React from 'react';
import { NavLink } from 'react-router-dom';
import { T } from '../../../../../Translations';
import MenuItemIcon from '../MenuItemIcon';
import { MenuItemContent } from '../menuItems';
import { observer } from 'mobx-react';
interface Props {
  menuItemContent: MenuItemContent;
  newTab?: boolean;
}
const MenuItem: React.FC<Props> = ({ menuItemContent, newTab = false }) => {
  return (
    <div
      className={clsx(
        'border-b-px border-b-slate-foreground md:border-b-none m-0 last:mr-0 lg:mr-3p',
      )}
    >
      <NavLink
        to={menuItemContent.to}
        target={newTab ? '_blank' : ''}
        className={({ isActive }) =>
          isActive
            ? clsx(
                'lg:cursor-teal-600 lg:border-b-2 lg:border-solid lg:pb-2',
                'border-teal-600 py-3.5 px-5 text-teal-600 lg:py-0 lg:px-0 lg:text-base',
                'block border-b-2 text-lg font-medium',
              )
            : clsx(
                'text-teal-600 lg:py-0 lg:px-0 lg:text-base lg:text-[#212121]',
                'border-b-2 border-solid border-teal-600 hover:text-teal-600',
                'block py-3.5 px-5 hover:border-b-2 hover:border-teal-600 lg:pb-2',
                'text-lg font-medium hover:pb-2 lg:border-transparent',
              )
        }
        data-test-menu-item={menuItemContent.rel}
      >
        <MenuItemIcon rel={menuItemContent.rel} />
        <T kind={menuItemContent.content} />
      </NavLink>
    </div>
  );
};
export default observer(MenuItem);
